module.exports = {
    RESET_CULTURES_FAMILIES: 'RESET_CULTURES_FAMILIES',
    RECEIVE_CULTURES_FAMILY: 'RECEIVE_CULTURES_FAMILY',
    RECEIVE_CULTURES_FAMILIES: 'RECEIVE_CULTURES_FAMILIES',
}
